module.exports = __webpack_public_path__ + "static/img/main_top_3.2d739bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/main_top_3.png
// module id = Smfu
// module chunks = 1